import snakecaseKeys from 'snakecase-keys'
import { serialize } from 'object-to-formdata'
import axiosIns from '@/plugins/axios'

export default {
  getHalls({
    isOperation = false,
    isSettings = false,
  }) {
    return axiosIns.get(
      '/waiter/halls',
      {
        params: snakecaseKeys({
          isOperation,
          isSettings,
        }),
      },
    )
  },
  // 予約ボード・卓作成ウィザード用の軽量概要（卓数+稼働中卓番号のみ）。
  // halls#index(isOperation) のフル取得より大幅に軽い
  async getHallOverview() {
    const res = await axiosIns.get('/waiter/halls/overview')

    return (res.data?.halls || []).map(hall => ({
      id: Number(hall.id),
      name: hall.name,
      tableCount: hall.table_count || 0,
      tablePrefix: hall.table_prefix || '',
      tableSuffix: hall.table_suffix || '',
      busyTableNumbers: (hall.busy_table_numbers || []).map(Number),
    }))
  },

  updateHall({ hallId, params }) {
    const formData = serialize(snakecaseKeys({ hall: params }))

    return axiosIns.put(`/waiter/halls/${hallId}/`, formData)
  },
  createHall({ params }) {
    const formData = serialize(snakecaseKeys({ hall: params }))

    return axiosIns.post('/waiter/halls/', formData)
  },
  deleteHall({ hallId }) {
    return axiosIns.delete(`/waiter/halls/${hallId}`)
  },
}
